export type Slice = { label: string; value: number; color?: string };

// Farbpalette (gut lesbar auf dunklem Grund). Letzte = Grau für „Übrige".
const PALETTE = ["#E8B84B", "#5AA9E6", "#E8734B", "#6BCB77", "#B47BE8", "#9AA0A6"];

function polar(cx: number, cy: number, r: number, angleDeg: number): [number, number] {
    const a = ((angleDeg - 90) * Math.PI) / 180; // 0° = oben
    return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
}

function PieChart({ slices, size = 220 }: { slices: Slice[]; size?: number }) {
    const total = slices.reduce((s, x) => s + (x.value > 0 ? x.value : 0), 0);
    if (total <= 0) {
        return <p className="admin-note">Noch keine Daten für ein Diagramm.</p>;
    }

    const cx = size / 2;
    const cy = size / 2;
    const r = size / 2 - 2;

    let angle = 0;
    const arcs = slices
        .map((s, i) => ({ ...s, color: s.color ?? PALETTE[i % PALETTE.length] }))
        .filter((s) => s.value > 0)
        .map((s) => {
            const frac = s.value / total;
            const start = angle;
            const end = angle + frac * 360;
            angle = end;
            return { ...s, start, end, frac };
        });

    return (
        <div className="admin-pie">
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="Verteilung">
                {arcs.map((s, i) => {
                    // Eine einzige (Voll-)Scheibe -> ganzer Kreis, sonst Tortenstück.
                    if (s.end - s.start >= 359.999) {
                        return <circle key={i} cx={cx} cy={cy} r={r} fill={s.color} />;
                    }
                    const [x1, y1] = polar(cx, cy, r, s.start);
                    const [x2, y2] = polar(cx, cy, r, s.end);
                    const large = s.end - s.start > 180 ? 1 : 0;
                    const d = `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`;
                    return <path key={i} d={d} fill={s.color} stroke="var(--gray-20)" strokeWidth="1" />;
                })}
            </svg>
            <ul className="admin-pie-legend">
                {arcs.map((s, i) => (
                    <li key={i}>
                        <span className="admin-pie-dot" style={{ background: s.color }} />
                        <span className="admin-pie-label">{s.label}</span>
                        <span className="admin-pie-pct">{(s.frac * 100).toFixed(1)}%</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PieChart;